import styled from "styled-components";

interface StyleProps {
  isActive?: boolean;
}

export const Container = styled.div.attrs({})`
  background-color: #fbf8fc;
  min-height: 40rem;
  max-height: 45rem;
  width: 75%;
  border-radius: 5px;
  padding: 1rem 7rem 1rem 7rem;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: lightgray;
    border-radius: 4px;
  }

  @media screen and (max-width: 1200px) and (min-width: 800px) {
    padding: 2rem 4rem 2rem 4rem;
    overflow-y: scroll;
  }
  /* @media screen and (max-width: 799px) { */
  @media screen and (max-width: 768px) {
    width: 95%;
    /* max-height: fit-content; */
    padding: 1rem 1rem 1rem 1rem;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
export const HeaderContainer = styled.div`
  display: flex;

  // justify-content: center;
  align-items: center;
  width: 100%;
`;
export const MediumContainer = styled.div.attrs({})`
  background-color: #fbf8fc;
  min-height: 20rem;
  max-height: 45rem;
  width: 40%;
  border-radius: 5px;
  padding: 2rem 2rem 2rem 2rem;

  @media screen and (max-width: 1200px) {
    width: 50%;
  }

  @media screen and (max-width: 850px) {
    width: 80%;
  }

  @media screen and (max-width: 400px) {
    width: 95%;
    padding: 2rem 1rem;
  }
`;

export const CloseIcon = styled.span`
  font-size: 45px;
  cursor: pointer;
  margin-right: 10px;
`;
export const Header = styled.div.attrs({
  className: "font-bold text-2xl text-center flex-1 flex",
})`
  justify-content: center;
  color: var(--primaryPurpleMain);
`;

export const Incidents = styled.div.attrs({
  className: "mt-3 flex flex-row",
})`
  flex-wrap: wrap;
  justify-content: center;
`;

export const Incident = styled.div.attrs({
  className: "py-2 lg:basis-1/4 md:basis-1/3 sm:basis-1/2 ",
})<StyleProps>`
  background: ${(props) =>
    props.isActive ? "var(--primaryPurpleMain)" : "white"};
  border-radius: 5px;
  box-shadow: 1px;
  border: 4px solid whitesmoke;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  cursor: pointer;
  border-radius: 7px;
  width: 150px;
  height: 170px;
  @media screen and (max-width: 768px) {
    height: 150px;
  }
`;

export const IncidentIcon = styled.img.attrs({})`
  height: 50px;
  width: 50px;
  color: red;
  fill: red;
  @media screen and (max-width: 1200px) and (min-width: 800px) {
    width: 40px;
    height: 40px;
  }
  @media screen and (max-width: 768px) {
    height: 50px;
    width: 50px;
  }
`;

export const IncidentLabel = styled.div.attrs({
  className: "text-md font-medium mt-5",
})<StyleProps>`
  color: ${(props) =>
    props.isActive ? "#FBF8FC" : "var(--primaryPurpleMain)"};
  text-align: center;
`;
export const ButtonContainer = styled.div`
  width: 100%;

  margin: 20px 0;
  display: flex;
  justify-content: flex-end;
  flex: 1;
  @media screen and (max-width: 425px) {
    justify-content: space-between;
  }
`;
export const NextBtn = styled.button.attrs({
  className: "rounded text-sm ml-5 float-right py-2 px-10",
})`
  background-color: var(--primaryPurpleMain);
  color: white;
  border: 1px solid var(--primaryPurpleMain);
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => props.disabled && "0.65"};
`;
export const CancelBtn = styled.button.attrs({
  className: "rounded text-sm float-right py-2 px-10 ml-5",
})`
  background-color: white;
  color: var(--primaryPurpleMain);
  border: 1px solid var(--primaryPurpleMain);
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
`;
